import {
  DashboardCrmPanel,
  DashboardLeadFieldsPanel,
  DashboardPlanPanel,
  DashboardSaveBar,
} from '@/components/dashboard/DashboardPanels';
import { DashboardHowItWorksLink } from '@/pages/dashboard/DashboardHelpPage';

export default function DashboardAutomationPage() {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Automation</h2>
        <p className="text-sm text-muted-foreground">
          Plan capabilities, lead fields, notifications, and CRM. Connect a calendar on Schedule before enabling
          in-chat booking.{' '}
          <DashboardHowItWorksLink hash="booking" />
        </p>
      </div>
      <DashboardPlanPanel />
      <DashboardLeadFieldsPanel />
      <DashboardCrmPanel />
      <DashboardSaveBar />
    </div>
  );
}
